import React, { useState, useEffect } from "react";
import Logo from "../elements/Logo";
import { connect } from "react-redux";
import { Nav, NavItem, Collapse, Navbar, NavbarToggler } from "reactstrap";
import { NavLink } from "react-router-dom";
import { REF_DATA, sitePermissionsNav } from "../constants";
import { getCookie } from "../helpers/CookieHandler";

const NavBar = ({ referenceData, showNavBar, permissions }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [menuList, setMenuList] = useState([]);
  const [expandBreakpoint, setExpandBreakpoint] = useState("md");
  const cookieCountry = getCookie("welcomeCountryCode");
  const cookieRole = getCookie("welcomeRole");
  const userCountry = cookieCountry || "";
  const userRole = cookieRole || "";

  const getExpandBreakpoint = (menuSize) => {
    if (menuSize < 7) {
      setExpandBreakpoint("md");
    } else if (menuSize < 10) {
      setExpandBreakpoint("lg");
    } else {
      setExpandBreakpoint("xl");
    }
  };

  const constructNavigation = (menuConfig = []) => {
    const permissibleNavUrls = [];
    const sortedMenuItems = [...menuConfig].sort(
      (a, b) => a.sortOrder - b.sortOrder,
    );

    if (sortedMenuItems.length > 0) {
      sortedMenuItems.forEach((navItem) => {
        if (
          userRole === "ABBVIE_EMPLOYEE" &&
          navItem.type === "Internal Site" &&
          navItem.pageName !== "Home"
        ) {
          if ((permissions || []).includes(sitePermissionsNav[navItem.pageName])) {
            if (navItem && navItem.enabled === true) {
              permissibleNavUrls.push({ ...navItem });
            }
          }
        } else {
          if (navItem && navItem.enabled === true) {
            permissibleNavUrls.push({ ...navItem });
          }
        }
      });
    } else {
      permissibleNavUrls.push({
        sortOrder: 1,
        url: "/",
        pageName: "Home",
        displayName: "Home",
        enabled: true,
        type: "Internal Site",
      });
    }

    return permissibleNavUrls;
  };

  useEffect(() => {
    if (referenceData && referenceData.MenuConfig) {
      const navigation = constructNavigation(referenceData.MenuConfig);
      getExpandBreakpoint(navigation.length);
      setMenuList(navigation);
    } else {
      setMenuList([]);
    }
  }, [referenceData, userRole, permissions]);

  const handleToggle = () => setIsOpen(!isOpen);

  const singleItemStyle = menuList.length === 1 ? { flex: "0 1 auto" } : {};
  const pagePath = window.location.pathname.toLowerCase();

  return (
    <nav className={`navbar navbar-1 mi-portal-navbar nav-${expandBreakpoint}`}>
      <div
        className={`container-${expandBreakpoint}`}
        style={{
          display: "flex",
          justifyContent: "end",
        }}
      >
        <div className="vertically-centered nav-logo">
          <Logo />
        </div>
        {pagePath === "/country-not-available" && (
          <div className="vertically-centered" style={{ fontSize: "18px" }}>
            <a href="/">
              <strong>Back</strong>
            </a>
          </div>
        )}
        {pagePath === "/admin/content-preview-page" && (
          <div
            className="vertically-centered"
            style={{
              color: "rgb(255,255,255)",
              fontSize: "18px",
              cursor: "pointer",
            }}
          >
            <strong onClick={() => window.history.back()}>Back</strong>
          </div>
        )}
      </div>
      {showNavBar && pagePath != "/admin/content-preview-page" && (
        <Navbar expand={expandBreakpoint} dark className="navbar-menu">
          <div className="vertically-centered align-right">
            <NavbarToggler onClick={handleToggle} className="nav-toggle" />
          </div>
          <div className="navbar-content">
            <div className={`container-${expandBreakpoint} navbar-container`}>
              <Collapse isOpen={isOpen} navbar>
                <Nav
                  navbar
                  className={`mi-portal-nav-items nav-${expandBreakpoint}`}
                >
                  {userRole && userCountry &&
                    menuList.length > 0 &&
                    menuList.map((menu) =>
                      menu.type === "Static Site" ? (
                        <NavItem
                          key={menu.sortOrder}
                          onClick={() => setIsOpen(false)}
                          style={singleItemStyle}
                        >
                          <NavLink
                            exact={true}
                            data-tag="track-link"
                            data-analytics-text={menu.pageName}
                            className={`nav-link ${
                              window.location.pathname === "/page"
                                ? "active"
                                : ""
                            }`}
                            to={`/page?name=${menu.TemplateId}`}
                          >
                            {menu.displayName}
                          </NavLink>
                        </NavItem>
                      ) : menu.type === "External Site" ? (
                        <NavItem
                          key={menu.sortOrder}
                          onClick={() => setIsOpen(false)}
                          style={singleItemStyle}
                        >
                          <a
                            href={menu.url}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-tag="track-link"
                            data-analytics-text={menu.pageName}
                            className="nav-link"
                          >
                            {menu.displayName}
                          </a>
                        </NavItem>
                      ) : (
                        <NavItem
                          key={menu.sortOrder}
                          onClick={() => setIsOpen(false)}
                          style={singleItemStyle}
                        >
                          <NavLink
                            exact={menu.pageName}
                            data-tag="track-link"
                            data-analytics-text={menu.pageName}
                            className={`nav-link ${
                              window.location.pathname.split("/")[1] ===
                              menu.url.split("/")[1]
                                ? "active"
                                : ""
                            }`}
                            to={menu.url}
                          >
                            {menu.displayName}
                          </NavLink>
                        </NavItem>
                      ),
                    )}
                </Nav>
              </Collapse>
            </div>
          </div>
        </Navbar>
      )}
    </nav>
  );
};

const mapStateToProps = (state) => {
  let referenceData = [];

  if (
    state.referenceData &&
    Array.isArray(state.referenceData) &&
    state.referenceData.length > 0
  ) {
    const refDataAction = state.referenceData.find(
      (item) => item.type === REF_DATA,
    );
    if (refDataAction && refDataAction.referenceData) {
      referenceData = refDataAction.referenceData;
    }
  }

  return {
    config: state.config,
    referenceData: referenceData,
    permissions: state.permissions,
  };
};
export default connect(mapStateToProps)(NavBar);



// WEBPACK FOOTER //
// ./src/mi-app/V2_NavBar.js